import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AllocationStatus, downloadAllocationStatus } from "../../Services/api";
import instance from "../../redux/api";
import { CommonButton } from "../common/commonButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TableContainer,
  Tooltip,
  Box,
  Typography,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { ViewAndEditEntity } from "./ViewAndEditEntity";
import MyComponent from "../EntityTableMaintainance/EntityDetails";
import { AddAllocationStatus } from "./AddAllocation";
import { commonToast, CommonFilterSidebar } from "../common";
import format from 'date-fns/format';
import FilterListIcon from "@mui/icons-material/FilterList";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import "../common/commonPageStyles.css";

//styles

const AssignBankStatementBar = {
  display: "flex",
  justifyContent: "space-between",
  height: 32,
  fontWeight: "400",
  marginTop: 10,
};
const editEntityUpdate = {
  width: "90px",
  padding: "18px 0px",
  borderRadius: "20px",
  gap: "8px",
}

const bankTransactionAddBtn = {
  color: 'white',
  backgroundColor: '#1672DE',
  borderRadius: '10px',
  padding: '10px 24px',
  fontWeight: '600',
  fontSize: '14px',
  textTransform: 'none',
  minHeight: '40px',
  minWidth: '120px',
  boxShadow: '0 2px 8px rgba(22, 114, 222, 0.2)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: '#1565c0',
    boxShadow: '0 4px 12px rgba(22, 114, 222, 0.3)',
    transform: 'translateY(-1px)',
  },
  '&:active': {
    transform: 'translateY(0)',
  },
  '&:disabled': {
    backgroundColor: '#CCCCCC',
    color: '#ffffff',
    boxShadow: 'none',
    cursor: 'not-allowed',
  },
};

const bankStatementSearchBar = {
  width: "180px",
  height: "30px",
  padding: "2px 5px 1px 15px",
  borderRadius: "7px",
  border: "1px solid #d2cccc",
  marginTop: "5px"
};

const ResetSubmit = {
  justifyContent: "flex-end",
  paddingTop: "0px",
  marginRight: "12px",
};
const addBankTransactionReset = {
  backgroundColor: "white",
  width: "90px",
  padding: "16px 0px",
  borderRadius: "20px",
  gap: "8px",
  color: "black",
  border: "1px solid black",
};

const EditPageContainerTransactions = {
  padding: "10px",
  cursor: "default",
  width: "100%",
  marginLeft: "-10px",
};
const EditPageContainerTransactionsList = {
  display: "flex",
  justifyContent: "end",
  width: "100%",
  alignItems: "center",
  marginBottom: "10px"
};

const CloseIconStyle = {
  backgroundColor: "transparent",
  color: "#ffff",
  height: "16px",
  width: "16px",
  padding: "7px 8px",
  borderRadius: "32px",
};
const addBankTransactionSubmit = {
  backgroundColor: "#1672DE",
  width: "90px",
  padding: "17px 0px",
  borderRadius: "13px",
  gap: "8px",
  color: "white",
  '&:hover': {
    backgroundColor: '#1565c0',
  }
};
const downloadBtn = {
  color: 'white',
  backgroundColor: '#1672DE',
  borderRadius: '10px',
  padding: '10px 24px',
  fontWeight: '600',
  fontSize: '14px',
  textTransform: 'none',
  minHeight: '40px',
  minWidth: '120px',
  boxShadow: '0 2px 8px rgba(22, 114, 222, 0.2)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  whiteSpace: "nowrap",
  '&:hover': {
    backgroundColor: '#1565c0',
    boxShadow: '0 4px 12px rgba(22, 114, 222, 0.3)',
    transform: 'translateY(-1px)',
  },
  '&:active': {
    transform: 'translateY(0)',
  },
  '&:disabled': {
    backgroundColor: '#CCCCCC',
    color: '#ffffff',
    boxShadow: 'none',
    cursor: 'not-allowed',
  },
};

export default function AllocationStatusContainer() {

  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const [rows, setRows] = useState([{ allocation_status: "", created_by: userData?.user_name ?? "" }]);
  const [tableRows, setTableRows] = useState([]);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [EntityDialog, setEntityDialog] = useState(false);
  const [editRow, setEditRow] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isCreated, setIsCreated] = useState(true);
  const [editId, setEditId] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(0);
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});
  const [validationStatus, setValidationStatus] = useState(
    Array(rows.length).fill(true)
  );

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const classes = useStyles();
  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
  };
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);
  const [searchFilter, setSearchFilter] = useState("");

  const handleDialogClose = () => {
    setEntityDialog(false);
    setEditMode(false)
    setViewMode(false)

    if (!editMode && !viewMode) {
      setRows([
        {
         allocation_status: "",
        },
      ]);
      setSelectedRows([false]);
      setValidationStatus([true]);
    }
    else if(editMode){
      setValidationStatus([true]);
      setCurrentUpdatedFiledsInEditMode({});
    }
  };

  const handleSearch = (value) => {
    setSearchFilter(value);
    if (value.trim() === '') {
      loadData();
    } else {
      const filteredData = tableRows.filter((row) =>
        columns.some((column) => {
          const cellValue = row[column.field];
          if (Array.isArray(cellValue)) {
            if (cellValue !== null && cellValue !== undefined) {
              return cellValue.some((item) =>
                Object.values(item).some(
                  (propValue) =>
                    propValue !== undefined &&
                    propValue !== null &&
                    propValue.toString().toLowerCase().includes(value.toLowerCase())
                )
              );
            }
          } else if (cellValue !== undefined && cellValue !== null) {
            return cellValue.toString().toLowerCase().includes(value.toLowerCase());
          }
          return false;
        })
      );
      setTableRows(filteredData);
    }
  };

  const handleApplyFilters = () => {
    handleSearch(searchFilter);
  };

  const handleClearFilters = () => {
    setSearchFilter("");
    loadData();
  };
  const handleCheckboxChange = (index, isChecked) => {
    const updatedSelectedRows = [...selectedRows];
    updatedSelectedRows[index] = isChecked;

    // Check the number of selected rows
    const selectedRowCount = updatedSelectedRows.filter(Boolean).length;

    setSelectedRows(updatedSelectedRows);
    setSelectAll(selectedRowCount === rows.length);
  };

  const handleActionButton = (rowData, isEditMode) => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      allocation_status: "",
    }));
    if (rowData && isEditMode) {
      // Pre-fill the empty row with data for editing
      setRows([{...rowData}]);
      setEditRow(rowData);
      setEditMode(true);
      setEditId(rowData.id);
      setIsCreated(false);
    } else if (rowData && !isEditMode) {
      setRows([rowData]);
      setViewMode(true);
    } else {
      // If no rowDataForEdit is provided, it means we are in add mode
      setRows(emptyRows);
      setIsCreated(true);
      setEntityDialog(true);
    }
    setEntityDialog(true);
    if (rowData) {
      setIsCreated(false);
    } else {
      setIsCreated(true);
    }
  };

  const handleReset = () => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      allocation_status: "",
    }));
    setRows(emptyRows);
    setSelectedRows([]);
    setSelectAll(false)
    setValidationStatus(Array.from({ length: rows.length }, () => (true)))
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.3, headerAlign: "center" },
    {
      field: "allocation_status",
      headerName: "Allocation Status",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "updated_by",
      headerName: "Last Modified By",
      flex: 1,
      headerAlign: "center",
      valueGetter:(params)=>params?.value??"-"
    },
    ...(userData?.role !== "CC Processor" ? [{
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      flex: 0.8,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {UserAuthorisation?.['View'] === "Y" && (
              <Tooltip title="View">
                <IconButton
                  onClick={() => handleActionButton(params.row, false)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}
            {UserAuthorisation?.['Edit'] === "Y" && (
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => handleActionButton(params.row, true)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <EditNoteIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    }] : [
      {
        field: "actions",
        headerName: "Actions",
        headerAlign: "center",
        flex: 0.8,
        renderCell: (params) => {
          return (
            <Tooltip title="View">
              <IconButton
                onClick={() => handleActionButton(params.row, false)}
                sx={{
                  backgroundColor: "rgba(22, 114, 222, 0.1)",
                  color: "#1672DE",
                  border: "1px solid #1672DE",
                  borderRadius: "8px",
                  padding: "6px",
                  width: "32px",
                  height: "32px",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.2)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                  },
                }}
              >
                <VisibilityIcon sx={{ fontSize: "16px" }} />
              </IconButton>
            </Tooltip>
          );
        },
      }
    ]),
  ];
  const loadData = async () => {
    try {
      setIsApiCallInprogress(true);
      const resp = await instance.get(AllocationStatus);
      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        const sortedData = resp.data.sort((a, b) => b.id - a.id);
        setTableRows(sortedData);
      } else {
        setTableRows([]);
      }
    } catch (err) {
      setIsApiCallInprogress(false);
      console.error("err", err);
    }
  };
  const UserAuthorisation =
    userData?.user_permissions?.permissions_list['Admin Table Maintenance'];

  useEffect(() => {
    loadData();
  }, []);
  const handleInputChange = (index, colName, value) => {
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      updatedRows[index][colName] = value;
      setRows(updatedRows);
      // Edit Mode
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [colName]: value,
        });
      }
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updatedSelectedRows = new Array(rows.length).fill(isChecked);

    setSelectedRows(updatedSelectedRows);
    setSelectAll(isChecked);
  };

  const handleAddRow = () => {
    setRows([...rows, { allocation_status: "" }]);
  };

  useEffect(() => {
    const selectedRowCount = selectedRows.filter(Boolean).length;
    if (selectedRowCount < rows.length) {
      setSelectAll(false)
    }
  }, [rows, selectedRows])


  const handleDeleteRow = () => {
    // Ensure there is at least one row remaining
    if (rows.length <= 1 || selectAll) {
      // Throw an error or show a message indicating that at least one row should remain
      commonToast("error", "At least One Row Should Remain!!");
      return;
    }

    const updatedRows = rows.filter((row, index) => !selectedRows[index]);
    setRows(updatedRows);

    // Clear selected rows and set Select All to false after deletion
    setSelectedRows([]);
    setSelectAll(false);
  };
  const validateRow = (index) => {
    const row = rows[index];
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (!row || !row.allocation_status || row.allocation_status.trim() === "") {
      fieldValidations.allocation_status = "This field is required";
    }

    // Add more validations for other fields...
    setValidationStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[index] = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };
  const handleSubmit = async () => {
    // Validate each row before submission
    const areRowsValid = rows
    .map((_, index) => validateRow(index))
    .every((value) => value);


    let editModeObj = {};
    if (!editMode) {
      // Add Mode
    } else {
      editModeObj.id = editRow?.id;
      editModeObj["updated_by"] = userData?.user_name ?? "";

      editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };
    }
    //const areRowsValid = true;

    if (!areRowsValid) {
      // If any row is invalid, stop the submission and display an error
      commonToast("error", "Please fill all required fields.");
      return;
    }

    try {
      let response;
      if (editMode) {
        response = await instance.patch(
          AllocationStatus + editId + "/",
          editModeObj
        );
        // clear preiously updated stored data
        setCurrentUpdatedFiledsInEditMode({});
      } else {
        rows.forEach((item, index) => {
          item.created_by = userData?.user_name ?? ""
        })
        response = await instance.post(AllocationStatus, rows);
      }

      if (response) {
        if (editMode) {
          commonToast("success", "Updated successfully !");
        } else {
          commonToast("success", "Submission successful !");
        }

        // clean up
        cleanupTransactionData();
      }
    } catch (err) {
      commonToast("error", "Submission failed. Please try again.");
    }
  };

  const cleanupTransactionData = () => {
    handleDialogClose();
    loadData();
  };
  const handleDownloadBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${downloadAllocationStatus}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `AllocationStatus_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Allocation Status data has been downloaded successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Allocation Status data could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Allocation Status data could not be downloaded");
    }
  }
  return (
    <>
      <style>
        {`
          /* Override DataGrid column headers to blue theme */
          .MuiDataGrid-root .MuiDataGrid-columnHeaders {
            background-color: #f8f9fa !important;
            border-bottom: 2px solid #e0e0e0 !important;
          }
          .MuiDataGrid-root .MuiDataGrid-columnHeader {
            background-color: transparent !important;
            color: #1672DE !important;
          }
          /* Override DataGrid selection colors to blue - override MUI theme primary color */
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected,
          .MuiDataGrid-root .MuiDataGrid-row[aria-selected="true"] {
            background-color: rgba(22, 114, 222, 0.08) !important;
          }
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected:hover,
          .MuiDataGrid-root .MuiDataGrid-row[aria-selected="true"]:hover {
            background-color: rgba(22, 114, 222, 0.12) !important;
          }
          .MuiDataGrid-root .MuiDataGrid-row:hover {
            background-color: rgba(22, 114, 222, 0.04) !important;
          }
          /* Override any orange/yellow colors from theme */
          .MuiDataGrid-root .MuiDataGrid-columnHeaders[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-columnHeader[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected[style*="ff5"] {
            background-color: rgba(22, 114, 222, 0.08) !important;
          }
        `}
      </style>
      <div style={Container}>
        {/* Filter Sidebar */}
        <CommonFilterSidebar
          isOpen={filterSidebarOpen}
          filterConfigs={[
            {
              type: "textInput",
              label: "Search",
              placeholder: "Search by allocation status...",
              value: searchFilter,
              onChange: (value) => setSearchFilter(value),
              onKeyUp: (e) => {
                if (e.code === "Enter") {
                  handleApplyFilters();
                }
              },
            },
          ]}
          onApplyFilters={handleApplyFilters}
          onClearFilters={handleClearFilters}
          isLoading={isApiCallInprogress}
          isFilterDisabled={false}
        />

        {/* Main Content Area */}
        <Box className="main-content-area">
          <Box className="page-header-container">
            <Typography variant="h5" className="page-heading">
              Allocation Status
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {UserAuthorisation?.["Creation"] === "Y" && (
                <>
                  <CommonButton
                    text="Add"
                    handleClick={() => handleActionButton()}
                    sx={bankTransactionAddBtn}
                    hoverColor="#1565c0"
                  />
                  <CommonButton
                    text="Export"
                    handleClick={handleDownloadBtnClick}
                    sx={downloadBtn}
                    hoverColor="#1565c0"
                    disabled={isDownloadInProgress}
                  />
                </>
              )}
              <IconButton
                onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                className="filter-toggle-button"
              >
                <FilterListIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              position: "relative",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              overflow: "hidden",
              transition: "all 0.3s ease",
              border: "1px solid #e8eaf0",
              "&:hover": {
                boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              },
            }}
          >
            <DataGrid
              className={classes.pagination}
              loading={isApiCallInprogress}
              rows={tableRows}
              columns={columns}
              rowCount={tableRows?.length}
              keepNonExistentRowsSelected
              disableSelectionOnClick
              pagination
              paginationMode="client"
              getRowId={(row) => row?.id}
              pageSizeOptions={[10, 25, 50, 100]}
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 25 },
                },
              }}
              sx={{
                border: "none",
                flex: 1,
                minHeight: 0,
                "& .MuiDataGrid-root": {
                  border: "none",
                  height: "100%",
                },
                "& .MuiDataGrid-main": {
                  height: "100%",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "2px solid #e0e0e0",
                  minHeight: "52px !important",
                  maxHeight: "52px !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "transparent",
                  fontWeight: "600",
                  color: "#1672DE",
                  fontSize: "14px",
                  padding: "12px 16px",
                  borderBottom: "none",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "#1672DE",
                  },
                  "& .MuiDataGrid-menuIcon": {
                    color: "#1672DE",
                  },
                },
                "& .MuiDataGrid-columnHeader[data-field='actions']": {
                  minWidth: toggle?.isOpen
                    ? "175.137px !important"
                    : "203px !important",
                },
                "& .MuiDataGrid-row": {
                  transition: "all 0.2s ease",
                  borderBottom: "1px solid #f0f0f0",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(22, 114, 222, 0.08) !important",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.12) !important",
                    },
                  },
                  "&:nth-of-type(even)": {
                    backgroundColor: "#fafafa",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                    },
                  },
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #f0f0f0",
                  padding: "12px 16px",
                  fontSize: "13px",
                  color: "#333",
                  display: "flex",
                  alignItems: "center",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                },
                "& .MuiDataGrid-virtualScroller": {
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "2px solid #e0e0e0",
                  borderBottom: "none",
                  backgroundColor: "#f8f9fa",
                  minHeight: "56px",
                  maxHeight: "56px",
                  paddingBottom: "8px",
                  paddingTop: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  position: "relative",
                  zIndex: 1,
                  display: "flex",
                  alignItems: "center",
                  "& .MuiTablePagination-root": {
                    color: "#666",
                    paddingRight: "16px",
                    margin: 0,
                    minHeight: "32px",
                  },
                  "& .MuiTablePagination-selectLabel": {
                    fontSize: "13px",
                    margin: 0,
                  },
                },
              }}
              components={{
                Toolbar: GridToolbarContainer,
                NoRowsOverlay: () => (
                  <Stack height="100%" alignItems="center" justifyContent="center">
                    No Allocation Status Records
                  </Stack>
                ),
              }}
            />
          </Box>
        </Box>
      </div>

      {/* <MyComponent /> */}

      <Dialog
        open={EntityDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle 
          id="alert-dialog-title" 
          sx={{ 
            cursor: "default", 
            backgroundColor: "#1672DE",
            color: "white",
            padding: "16px 24px" 
          }}
        >
          {viewMode ? "View Allocation Status" : editMode ? "Edit Allocation Status" : "Add Allocation Status"}
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            style={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon style={CloseIconStyle} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ overflowX: "hidden", padding: "20px 24px 5px 24px" }}
        >
          <div elevation={4} style={EditPageContainerTransactions}>
            {!editMode && !viewMode && (
              <div style={EditPageContainerTransactionsList}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <CommonButton
                    // sx={addBankTransactionAdd}
                    text="Add"
                    handleClick={handleAddRow}
                    icon={<AddIcon style={{ height: "18px" }} />}
                    hoverColor="#1565c0"
                    sx={{
                      backgroundColor: "#1672DE",
                      color: "white",
                      borderRadius: "10px",
                      padding: "8px 16px",
                      "&:hover": {
                        backgroundColor: "#1565c0",
                      }
                    }}
                  />
                  <CommonButton
                    sx={{
                      backgroundColor: selectedRows.filter(Boolean).length > 0 ? "#1672DE" : "#CCCCCC",
                      color: selectedRows.filter(Boolean).length > 0 ? "white" : "black",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "17px 10px",
                      borderRadius: "15px",
                      "&:hover": {
                        background: selectedRows.filter(Boolean).length > 0 ? "#1565c0" : "#CCCCCC",
                      },
                    }}
                    text="Delete"
                    handleClick={handleDeleteRow}
                    disabled={selectedRows.filter(Boolean).length === 0}
                    icon={<DeleteIcon style={{ height: "19px" }} />}
                  />
                </div>
              </div>
            )}
            {isCreated ? (
              <TableContainer style={{ maxHeight: "300px" }}>
                <AddAllocationStatus
                  selectAll={selectAll}
                  handleInputChange={handleInputChange}
                  handleSelectAll={handleSelectAll}
                  rows={rows}
                  // handleBlur={handleBlur}
                  handleCheckboxChange={handleCheckboxChange}
                  validationStatus={validationStatus}
                  selectedRows={selectedRows}
                />
              </TableContainer>
            ) : (
              <>
                {rows?.map((row, index) => (
                  <Grid display={"flex"} flexDirection={"column"}>
                    <ViewAndEditEntity
                      row={row}
                      index={index}
                      viewMode={viewMode}
                      validationStatus={validationStatus}
                      editMode={editMode}
                      handleInputChange={handleInputChange}
                    />
                  </Grid>
                ))}
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions style={ResetSubmit}>
          {viewMode ?
            null :
            <>
              {isCreated &&
                <CommonButton
                  sx={addBankTransactionReset}
                  text="Reset"
                  handleClick={() => handleReset()}
                  disabled={editMode}
                />
              }
              {
                editMode && (
                  <CommonButton
                    sx={{
                      ...editEntityUpdate,
                      backgroundColor: "#1672DE",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#1565c0",
                      }
                    }}
                    text='Update'
                    handleClick={handleSubmit}
                    disabled={Object.keys(currentUpdatedFiledsInEditMode)?.length <= 0}
                    hoverColor="#1565c0"
                  />)
              }
              {!editMode && !viewMode && (
                <CommonButton
                  sx={addBankTransactionSubmit}
                  text='Submit'
                  handleClick={handleSubmit}
                  hoverColor="#1565c0"
                />)
              }
            </>
          }
        </DialogActions>
      </Dialog>
    </>
  );
}
